import UploadField, { UploadFieldProps } from './UploadField';

export type { UploadFieldProps };
export default UploadField;
